import SongWithSort from "./SongWithSort";
import Tournament from "./Tournament";

/**
 * 勝ち抜き戦を繰り返して上位 k 曲を順位付きで決める。
 *
 * 1位が決まったら、「既に順位が決まった曲以外には負けていない曲」だけを
 * 集めて再度勝ち抜き戦を行い、次の順位を決める。
 * songs の並び順がそのまま対戦の組み分けになるので、
 * 強さが近いと思われる曲を隣接させて渡す（シード）と試合数が減る。
 */
export default class TopSelector {
  private readonly songs: SongWithSort[];

  private readonly k: number;

  private readonly groupSize: number;

  private readonly ranked: SongWithSort[] = [];

  private tournament: Tournament;

  private finished = false;

  constructor(songs: SongWithSort[], k: number, groupSize: number) {
    this.songs = songs;
    this.k = k;
    this.groupSize = groupSize;
    this.tournament = new Tournament(songs.slice(), groupSize);
    this.advance();
  }

  public isFinished(): boolean {
    return this.finished;
  }

  public result(): SongWithSort[] {
    return this.ranked.slice();
  }

  /** 次に人が選ぶ対戦曲。isFinished() が false のときのみ有効。 */
  public next(): SongWithSort[] {
    return this.tournament.next();
  }

  /** 今決めようとしている順位（1始まり）。 */
  public currentRank(): number {
    return this.ranked.length + 1;
  }

  /** 次の試合が、今の順位を決める決勝かどうか。 */
  public isFinal(): boolean {
    return this.tournament.isFinal();
  }

  public select(winner: SongWithSort) {
    this.tournament.select(winner);
    this.advance();
  }

  private advance() {
    while (!this.tournament.hasNext()) {
      this.ranked.push(this.tournament.winner());
      if (this.ranked.length >= this.k) {
        this.finished = true;
        return;
      }
      // 次の順位の候補 = 既に順位が決まった曲以外には負けていない曲
      const candidates = this.songs
        .filter(v => !this.isRanked(v))
        .filter(v => v.looses.every(l => this.isRanked(l)));
      if (candidates.length === 0) {
        this.finished = true;
        return;
      }
      // 候補が1曲なら不戦勝。その曲にだけ負けていた曲が次の候補になるので続行する。
      console.log(`Create new tournament: ${candidates.length}`);
      this.tournament = new Tournament(candidates, this.groupSize);
    }
  }

  private isRanked(song: SongWithSort): boolean {
    return Boolean(this.ranked.find(v => v.id === song.id));
  }
}
